import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'
import JSONUtils from '@/utils/JSONUtils'

async function createLostObjectReport (lostObject, cityId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'lost-objects')
    const response = await axios.post(url, lostObject)

    return JSONUtils.resolveRefs(response.data)
}

async function fetchLostObjects (cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'lost-objects')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })


    return JSONUtils.resolveRefs(response.data)
}

async function fetchPublishedLostObjects (cityId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'lost-objects', 'published')
    const response = await axios.get(url)


    return JSONUtils.resolveRefs(response.data)
}

async function patchLostObjects (cityId, token, objects)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'lost-objects')
    const response = await axios.patch(url, objects, { headers: { Authorization: `Bearer ${token}` } })

    return JSONUtils.resolveRefs(response.data)
}

async function getLostObjectsTagsDefinition (cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'lost-objects', 'tags')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return JSONUtils.resolveRefs(response.data)
}

async function setLostObjectsTagsDefinition (cityId, token, objects)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'lost-objects', 'tags')
    const response = await axios.patch(url, objects, { headers: { Authorization: `Bearer ${token}` } })

    return JSONUtils.resolveRefs(response.data)
}

export default { createLostObjectReport, fetchLostObjects, fetchPublishedLostObjects, patchLostObjects,
    getLostObjectsTagsDefinition, setLostObjectsTagsDefinition }


// WEBPACK FOOTER //
// ./src/services/lostObjects.js